import { Button } from 'reactstrap';
import SettingsIcon from './SettingsIcon';

function ReportFilterToggleBar({ onShow, onSettings, className = '' }) {
    return (
        <div className={`report-filter-toggle-bar ${className}`.trim()}>
            {onSettings ? (
                <SettingsIcon onClickHandler={onSettings} variant="inline" />
            ) : null}
            <Button
                color="primary"
                outline
                size="sm"
                type="button"
                className="report-filter-toggle-btn"
                onClick={onShow}
            >
                <i className="fa fa-filter" aria-hidden="true" />
                {' '}
                Show Filters
            </Button>
        </div>
    );
}

export default ReportFilterToggleBar;
